import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import './style.css';
import { Colors } from 'app/constants/color';

export default function Loader({ style, color = Colors.primary }) {
  return (
    <div className='modal' style={style}>
      <CircularProgress size='4rem' sx={{ color }} />
    </div>
  );
}
